const initialState = [
]


export default function products(state=initialState, action) {

  switch (action.type) {

    case 'FETCH_PRODUCTS':
      return action.products

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/products.js